import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function TabsSection() {
  return (
    <Card className='mb-8'>
      <CardHeader>
        <CardTitle>Tabs</CardTitle>
        <CardDescription>Organized content in tabs</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue='account' className='w-full'>
          <TabsList className='grid w-full grid-cols-3'>
            <TabsTrigger value='account'>Account</TabsTrigger>
            <TabsTrigger value='password'>Password</TabsTrigger>
            <TabsTrigger value='settings'>Settings</TabsTrigger>
          </TabsList>
          <TabsContent value='account' className='space-y-2'>
            <div className='space-y-2'>
              <Label htmlFor='name'>Name</Label>
              <Input id='name' defaultValue='Pedro Duarte' />
            </div>
            <div className='space-y-2'>
              <Label htmlFor='username'>Username</Label>
              <Input id='username' defaultValue='@peduarte' />
            </div>
          </TabsContent>
          <TabsContent value='password' className='space-y-2'>
            <div className='space-y-2'>
              <Label htmlFor='current'>Current password</Label>
              <Input id='current' type='password' />
            </div>
            <div className='space-y-2'>
              <Label htmlFor='new'>New password</Label>
              <Input id='new' type='password' />
            </div>
          </TabsContent>
          <TabsContent value='settings' className='space-y-2'>
            <div className='space-y-2'>
              <Label htmlFor='theme'>Theme</Label>
              <Select>
                <SelectTrigger>
                  <SelectValue placeholder='Select a theme' />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value='light'>Light</SelectItem>
                  <SelectItem value='dark'>Dark</SelectItem>
                  <SelectItem value='system'>System</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
